export default __webpack_public_path__ + "static/media/moviehive.4f225ca7.png";